import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import 'bulma/css/bulma.css';
import 'bulma-quickview/dist/css/bulma-quickview.min.css';
import bulmaQuickview from 'bulma-quickview/src/js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from './fontawesome';
import { faEye, faCheck, faTimes, faBell, faFilter, faEyeSlash, faChartBar, faTable, faCheckCircle, faSpinner, faTimesCircle, faArrowRight, faClock, faExclamationTriangle, faPauseCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import Vuelidate from '@vuelidate/core'; // Import the default export

store.commit('initializeStore') 

library.add(faEye, faCheck, faTimes, faBell, faFilter, faEyeSlash, faChartBar, faTable, faCheckCircle, faSpinner, faTimesCircle, faArrowRight, faClock, faExclamationTriangle, faPauseCircle, faRedo);

let apiBaseURL = '';

if (window.location.host.includes('bpmb-dev')) {
  apiBaseURL = process.env.VUE_APP_API_BASE_URL_DEV || 'https://bpmb-dev.despaq.com/';
} else if (window.location.host.includes('bpmb.despaq.com')) {
  apiBaseURL = process.env.VUE_APP_API_BASE_URL_PROD || 'https://bpmb.despaq.com/';
} else {
  apiBaseURL = 'https://bpmb.despaq.com/';
}

axios.defaults.baseURL = apiBaseURL;

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Token ${token}`;
}

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Vuelidate); // Use Vuelidate as a plugin

app.component('font-awesome-icon', FontAwesomeIcon);

// Initialize Bulma Quickview
document.addEventListener('DOMContentLoaded', () => {
  bulmaQuickview.attach();
});

app.mount('#app');

<script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script>

